const SELECTOR = '.section-fade-in-target, .fixed-home > .fixed-home__wrap, .fixed-home > .fixed-home__difference, main > .shopify-section:not(.fixed-home-wrapper):not(:has(.section-fade-in-target)), footer > .shopify-section:not(:has(.password-footer))';
const VISIBLE_CLASS = 'section-fade-in--visible';
const READY_CLASS = 'section-fade-in-ready';

function revealSection(section) {
  section.classList.add(VISIBLE_CLASS);
}

function initSectionFadeIn() {
  const sections = Array.from(document.querySelectorAll(SELECTOR));

  if (!sections.length) return;

  document.documentElement.classList.add(READY_CLASS);

  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    sections.forEach(revealSection);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        revealSection(entry.target);
        observer.unobserve(entry.target);
      });
    },
    {
      rootMargin: '0px 0px -12% 0px',
      threshold: 0.12,
    }
  );

  sections.forEach((section, index) => {
    section.style.setProperty('--section-fade-delay', `${Math.min(index * 70, 280)}ms`);
    observer.observe(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSectionFadeIn, { once: true });
} else {
  initSectionFadeIn();
}
